/* eslint-disable */
import services from 'services';
import * as types from './mutation-types';

export default {
  loginWithUserToken: async ({ commit }, userToken) => {
    commit(types.LOGIN, { user: {}, userToken: userToken });
  },
  loginUser: async ({ commit }, user) => {
    commit(types.LOGIN, { user });
  },
  /**
   * Adds user to state and set state.authenticated value to true
   */
  loginWithCredentials: async ({ commit, dispatch, rootGetters }, { email, password }) => {
    const user = await services.authService.loginWithCredentials(email, password);
    dispatch('loginUser', user);
  },
  /**
   * Removes user from state and reset state.authenticated
   */
  logout: ({ commit, dispatch }) => {
    return services.authService.logout().then(() => {
      commit(types.LOGOUT);
    });
  },
  /**
   * Replaces state.user by firebase.auth().currentUser
   */
  updateUser: async ({ commit }) => {
    const user = services.authService.currentUser();
    commit(types.UPDATE_USER, user);
  },

  fetchCurrentUserProfile: async ({ commit, getters }, userId) => {
    let currentUserId = userId;
    if (!currentUserId) {
      currentUserId = getters['currentUserId'];
    }
    console.log('currentUserId', currentUserId);
    const profile = await services.userService.getUser(currentUserId);
    commit('SET_USER_PROFILE', profile);
    return profile;
  },
};
